import styled from 'styled-components'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

export const CheckCircle = styled(CheckCircleIcon)`
  color: ${(p) => p.theme.palette.success.main};
`
